"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n\n  transform: translateY(-0.75em);\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  & > :first-child {\n    margin-bottom: 0.1875rem;\n  }\n\n  &:hover [data-meta='image-option'] {\n    box-shadow: 0px 10px 13px -7px rgba(0, 0, 0, 0.25),\n      5px 5px 15px 5px rgba(0, 0, 0, 0);\n    outline: 0.4rem solid var(--color-primary-light-2);\n    outline-offset: 0.8rem;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var image_scenario_node_styles_1 = require("../image-scenario-node/image-scenario-node.styles");

exports.StyledEditableImageNodeWrapperDiv = styled_components_1.default(image_scenario_node_styles_1.StyledImageNodeWrapperDiv)(_templateObject());
exports.StyledEditableOptionsUl = styled_components_1.default(image_scenario_node_styles_1.StyledOptionsUl)(_templateObject2());
exports.StyledEditableOptionLi = styled_components_1.default(image_scenario_node_styles_1.StyledOptionLi)(_templateObject3());
exports.StyledRemoveOptionButtonWrapperDiv = styled_components_1.default.div(_templateObject4());
exports.StyledActionViewWrapperDiv = styled_components_1.default.div(_templateObject5());